module.exports = __webpack_public_path__ + "static/img/dashboard_empty_state_icon.71b90f0.svg";